import { Trans, useTranslation } from 'react-i18next'
import CouponIcon from '@mui/icons-material/LocalOfferOutlined'

import { subtract } from '../../../utils/money'
import {
  useGetQuoteCheapestPrice,
  useGetQuotePrice,
  type Quote,
} from '../../../modules/quotes'
import Tooltip from '../../Tooltip'
import Price from '../../Price'
import { useQuoteContext } from '../QuoteComponent.context'

type CheapestPriceProps = {
  quote: Quote
}

const CheapestPrice: React.FC<CheapestPriceProps> = ({ quote }) => {
  const { t } = useTranslation()
  const { promoCode, presentationMode } = useQuoteContext()
  const cheapestPrice = useGetQuoteCheapestPrice()(quote, { promoCode })
  const { price } = useGetQuotePrice()(quote, { promoCode })

  if (!cheapestPrice || presentationMode) {
    return null
  }

  const cheaperPriceDiff = subtract(price, cheapestPrice).price
  if (cheaperPriceDiff <= 0) {
    return null
  }

  const StrongCheapestPrice = () => <strong>{ cheaperPriceDiff }$</strong>

  return (
    <Tooltip
      tooltip={(
        <div className="p-4 text-center font-sans text-base leading-tight text-green-700">
          <Trans i18nKey="quotes.quote.cheapestPrice.saveMoney">
            <StrongCheapestPrice />
          </Trans>
        </div>
      )}
      className="bg-green-50"
    >
      { !presentationMode && (
        <div className="hidden items-center gap-1 whitespace-nowrap rounded-md bg-green-50 px-2 py-1 font-sans text-sm leading-tight text-green-700 xs:flex sm:gap-2 sm:pl-2 sm:pr-4">
          <CouponIcon className="!hidden rotate-90 !text-[18px] sm:!block" />
          <div>
            { t('quotes.quote.cheapestPrice.from') }
            <br />
            <span className="font-bold">
              <Price amount={cheapestPrice} showDecimals={false} />
            </span>
          </div>
        </div>
      ) }
    </Tooltip>
  )
}

export default CheapestPrice
